import { useCallback, memo } from 'react';
import Particles from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';

const ParticleBackground = memo(() => {
  const particlesInit = useCallback(async (engine: any) => {
    try {
      await loadSlim(engine);
    } catch (error) {
      console.error('Failed to load particle engine:', error);
    }
  }, []);

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      className="fixed inset-0 -z-10"
      options={{
        background: {
          color: {
            value: 'transparent',
          },
        },
        fpsLimit: 120,
        interactivity: {
          events: {
            onClick: {
              enable: false,
            },
            onHover: {
              enable: true,
              mode: 'bubble',
            },
            resize: true,
          },
          modes: {
            bubble: {
              distance: 200,
              duration: 2,
              opacity: 0.8,
              size: 0,
            },
          },
        },
        particles: {
          color: {
            value: '#cccccc',
          },
          links: {
            color: '#cccccc',
            distance: 150,
            enable: true,
            opacity: 0.5,
            width: 1,
          },
          move: {
            enable: true,
            speed: 0.5,
            direction: 'none',
            random: false,
            straight: false,
            outModes: {
              default: 'bounce',
            },
          },
          number: {
            density: {
              enable: true,
              area: 1200,
            },
            value: 40,
          },
          opacity: {
            value: 0.8,
          },
          shape: {
            type: 'circle',
          },
          size: {
            value: { min: 1, max: 3 },
          },
        },
        detectRetina: true,
        responsive: [
          {
            maxWidth: 768,
            options: {
              particles: {
                number: {
                  value: 20,
                },
                links: {
                  distance: 100,
                },
              },
            },
          },
        ],
        pauseOnBlur: true,
        pauseOnOutsideViewport: true,
      }}
    />
  );
});

ParticleBackground.displayName = 'ParticleBackground';

export default ParticleBackground;